import { render, staticRenderFns } from "./ed-course.vue?vue&type=template&id=ad5fa788&scoped=true&"
import script from "./ed-course.ts?vue&type=script&lang=ts&"
export * from "./ed-course.ts?vue&type=script&lang=ts&"
import style0 from "./ed-course.scss?vue&type=style&index=0&id=ad5fa788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5fa788",
  null
  
)

export default component.exports